import {useCallback} from 'react';

import {useReadOnlyDataHook} from 'src/hooks/use-read-only-data-hook';
import {getAccessRightsProfiles} from 'src/openapi/admin/apis/GetAccessRightsProfilesApi';
import {useAppDispatch} from 'src/store/hooks';

export const useRolesPermissions = () => {
    const apiDispatch = useAppDispatch();

    const getDispatchAction = useCallback((signal: AbortSignal) => apiDispatch(
        getAccessRightsProfiles({signal}),
    ), [apiDispatch]);

    return useReadOnlyDataHook({
        initValue: [],
        getDispatchAction,
    });
};
